import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50" data-id="element-102">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-103">
        <div className="flex items-center" data-id="element-104">
          <a href="#" className="text-2xl font-bold text-blue-600" data-id="element-105">
            Vaxtech Group SAS
          </a>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-106">
          <a href="#" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-107">
            Inicio
          </a>
          <a href="#services" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-108">
            Servicios
          </a>
          <a href="#about" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-109">
            Sobre Nosotros
          </a>
          <a href="https://wa.me/5491150026793" target="_blank" rel="noopener noreferrer" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-110">
            Contacto
          </a>
          <a href="https://wa.me/5491150026793" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-5 py-2 rounded-md font-medium hover:bg-blue-700 transition-colors" data-id="element-111">
            Solicitar cotización
          </a>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-800" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-112">
          {isMenuOpen ? <X size={24} data-id="element-113" /> : <Menu size={24} data-id="element-114" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <nav className="md:hidden bg-white py-4 px-4 shadow-md" data-id="element-115">
          <div className="flex flex-col space-y-4" data-id="element-116">
            <a href="#" className="text-gray-800 hover:text-blue-600 font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-117">
              Inicio
            </a>
            <a href="#services" className="text-gray-800 hover:text-blue-600 font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-118">
              Servicios
            </a>
            <a href="#about" className="text-gray-800 hover:text-blue-600 font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-119">
              Sobre Nosotros
            </a>
            <a href="https://wa.me/5491150026793" target="_blank" rel="noopener noreferrer" className="text-gray-800 hover:text-blue-600 font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-120">
              Contacto
            </a>
            <a href="https://wa.me/5491150026793" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-5 py-2 rounded-md font-medium hover:bg-blue-700 transition-colors text-center" onClick={() => setIsMenuOpen(false)} data-id="element-121">
              Solicitar cotización
            </a>
          </div>
        </nav>}
    </header>;
}